import { Link, useLocation } from "react-router-dom";
import * as userService from "../../utilities/users-service";
import { GiSpermWhale } from "react-icons/gi";

export default function NavBar({ user, setUser }) {
  const location = useLocation();
  const isStampShow =
    /^\/stamps\/[^/]+$/.test(location.pathname) &&
    !location.pathname.endsWith("/edit") &&
    !location.pathname.endsWith("/new");
  const isDark = isStampShow;

  function handleLogOut() {
    userService.logOut();
    setUser(null);
  }

  const textColor = isDark ? "text-white" : "text-black";

  return (
    <nav className="pt-8 pb-5">
      <div className="max-w-7xl mx-auto px-6 flex flex-row justify-start items-center gap-5">
        <Link className={`no-underline ${textColor} text-3xl font-bold`} to="/">
          Posuto / ポスト
        </Link>
        <div className="ml-auto flex flex-row justify-center items-center">
          {user && user.isAdmin ? (
            <>
              <Link className={`px-4 no-underline ${textColor}`} to="/admin">
                <h4>Admin</h4>
              </Link>
              <Link className={`px-4 no-underline ${textColor}`} to="/hidden">
                <h4>Hidden</h4>
              </Link>
              <Link
                className={`px-4 no-underline ${textColor}`}
                to="stamps/new"
              >
                <h4>Add stamp</h4>
              </Link>
              <Link
                className={`px-4 no-underline ${textColor}`}
                to="/"
                onClick={handleLogOut}
              >
                <h4>Log out</h4>
              </Link>
            </>
          ) : // <Link className={`px-4 no-underline ${textColor}`} to="/login">
          //   <h4>Log in</h4>
          // </Link>
          null}
        </div>
      </div>
    </nav>
  );
}
